import { TODO } from '@b2b/types/core';

/**
 * Check if a price is valid (not null and not a word/non-numerical string)
 */
export function isValidPrice(price: string | null): boolean {
  if (price == null) {
    return false;
  }

  // Check if the string is a valid number
  const numValue = parseFloat(price);
  if (isNaN(numValue)) {
    return false;
  }

  return true;
}

/**
 * Convert string or number to an integer value
 */
export function currencyFloatToInteger(value: string | number, options: Partial<{ significant: number }> = {}) {
  const sigs = options.significant ? options.significant : 2;
  let result = 0;

  if (typeof value === 'string') {
    result = parseFloat(value);
  } else if (typeof value === 'number') {
    result = value;
  }

  if (isNaN(result)) {
    result = 0;
  } else {
    const decimal = (result * Math.pow(10, sigs)) as TODO;
    result = parseInt(decimal, 10);
    const round = decimal.toString().split('.')[1];
    if (round) {
      const digit = parseInt(round.charAt(0), 10) as TODO;
      if (parseInt(digit, 10) >= 5) {
        result += 1;
      }
    }
  }

  return result;
}

/**
 * Convert string or number to an integer value with significant digits
 */
export function integerToCurrencyFloat(
  value: number | string,
  options: Partial<{ significant: number; enforceFixed: boolean }> = {}
) {
  const sigs = options.significant ? options.significant : 2;
  let result = 0;

  if (typeof value === 'number') {
    result = value;
  }

  if (isNaN(result)) {
    result = 0;
  } else {
    const decimal = result / Math.pow(10, sigs);
    result = decimal;
    const round = decimal.toString().split('.')[1];

    if (round && round.length > 2) {
      const digit = parseInt(round.charAt(2), 10) as TODO;
      if (parseInt(digit, 10) >= 5) {
        result += 1;
      }
    }
  }

  if (options.enforceFixed) {
    result = result.toFixed(2) as TODO;
  }

  return result;
}
